import { IDraftOrderPayload, IDraftOrder } from '@customTypes/draftOrder';
import axios from '@hooks/useAxios';

const draftOrderBaseUrl = '/draft-requisition';

export const fetchDraftOrders = async (): Promise<IDraftOrder[]> => {
  return axios.get(draftOrderBaseUrl).then(res => res.data);
};

export const createDraftOrder = async (payload: IDraftOrderPayload): Promise<string> => {
  return axios.post(draftOrderBaseUrl, payload, { skipResponseInterceptor: true }).then(res => res.data);
};

export const getDraftOrderDetail = async (draftOrderId: string): Promise<IDraftOrder> => {
  return axios.get(`${draftOrderBaseUrl}/${draftOrderId}`).then(res => res.data);
};

export const updateDraftOrder = async (draftOrderId: string, payload: IDraftOrderPayload): Promise<string> => {
  return axios
    .patch(`${draftOrderBaseUrl}/${draftOrderId}`, payload, { skipResponseInterceptor: true })
    .then(res => res.data);
};

export const deleteDraftOrder = async (draftOrderId: string): Promise<string> => {
  return axios.delete(`${draftOrderBaseUrl}/${draftOrderId}`).then(res => res.data);
};
